import { Box, Typography, Button } from '@mui/material';
import { useInterval } from 'common/hooks/useInterval';
import React, { useState } from 'react';
import { useTranslation } from 'services/localization';

interface Props {
	url: string;
	closeView: () => void;
}

export const ManualRedirect = ({ url, closeView }: Props) => {
	const { t } = useTranslation();
	const [secondsToClose, setSecondsToClose] = useState<number>(9);

	useInterval(() => {
		const _secondsToClose = secondsToClose - 1;
		if (_secondsToClose <= 0) {
			closeView();
		} else {
			setSecondsToClose(_secondsToClose);
		}
	}, 1000);

	return (
		<Box textAlign="center">
			<Typography variant="body1">
				{t(
					'account.payments.manualRedirectInfo',
					'If you did not get automatically redirected, you can click the button below to continue to verify your information',
				)}
				.
			</Typography>
			<Box mb={4} />
			<Button variant="outlined" color="primary" component="a" href={url}>
				{t('account.payments.continueToVerification', 'Continue to verification')}
			</Button>
			<Box mb={4} />
			<Typography variant="body2" color="secondary">
				{t('account.payments.viewWillClose', {
					defaultValue: 'This view will automatically close in {{seconds}}s',
					seconds: secondsToClose,
				})}
			</Typography>
		</Box>
	);
};
